import React, { useState, useEffect } from 'react';
import MultiSelectSupervisor from './MultiSelectSupervisor';
import '../App.css';

function CreateTaskModal({ isOpen, onClose, onAddTask, taskData, onTaskDataChange, supervisors, contractors, branches }) {
  const [selectedManagers, setSelectedManagers] = useState(taskData.managers || []);
  const [selectedAssistants, setSelectedAssistants] = useState(taskData.assistants || []);
  const [branchOptions, setBranchOptions] = useState([]);
  const [headquartersOptions, setHeadquartersOptions] = useState([]);
  const [branchMap, setBranchMap] = useState({});

  useEffect(() => {
    if (branches && branches.length > 0) {
      const uniqueHQs = [...new Set(branches.map(branch => branch.headquarters))];
      setHeadquartersOptions(uniqueHQs);

      const newBranchMap = branches.reduce((acc, branch) => {
        if (!acc[branch.headquarters]) {
          acc[branch.headquarters] = [];
        }
        acc[branch.headquarters].push(branch.name);
        return acc;
      }, {});
      setBranchMap(newBranchMap);
    }
  }, [branches]);

  useEffect(() => {
    if (taskData.headquarters && branchMap[taskData.headquarters]) {
      setBranchOptions(branchMap[taskData.headquarters]);
    } else {
      setBranchOptions([]);
    }
  }, [taskData.headquarters, branchMap]);

  const handleAddressSearch = () => {
    const width = 500; //팝업의 너비
    const height = 600; //팝업의 높이
    new window.daum.Postcode({
      oncomplete: function(data) {
        let eupMyeonDongPart = '';
        if (data.bname1 && data.bname1.trim() !== '') {
            eupMyeonDongPart = data.bname1; // Use bname1 (e.g., "초월읍")
        } else if (data.bname && data.bname.trim() !== '') {
            eupMyeonDongPart = data.bname; // Fallback to bname (e.g., "송정동")
        } else if (data.eupmyeondong && data.eupmyeondong.trim() !== '') {
            eupMyeonDongPart = data.eupmyeondong; // Last resort
        }
        const formattedAddress = `${data.sido} ${data.sigungu} ${eupMyeonDongPart}`;
        console.log('Formatted Address being saved:', formattedAddress); // 추가된 로그

        onTaskDataChange({ target: { name: 'address', value: formattedAddress } });
      }
    }).open({
      left: (window.screen.width / 2) - (width / 2),
      top: (window.screen.height / 2) - (height / 2)
    });
  };

  useEffect(() => {
    setSelectedManagers(taskData.managers || []);
    setSelectedAssistants(taskData.assistants || []);
  }, [taskData]);

  // isOpen이 false이면 아무것도 렌더링하지 않음 (모달 숨김)
  if (!isOpen) {
    return null;
  }

  return (
    // 모달 배경 (어둡게 처리)
    <div className="modal-overlay" onClick={onClose}>
      {/* 모달 컨텐츠 (배경 클릭 시 이벤트 전파 방지) */}
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-button" onClick={onClose}>×</button>
        <h1>신규 공사 등록 </h1>
        <p style={{ color: 'red', fontSize: '0.9em', textAlign: 'center' }}>({'\u00A0'}*{'\u00A0'}){'\u00A0'}{'\u00A0'}은 필수입력항목입니다.</p>
        <br/><hr/><br/>
        <form onSubmit={onAddTask}>
          <div className="form-grid">
            <div className="form-group">
              <label>1. 번호<span className="required-dot">*</span></label>
              <input className="form-control" type="text" name="displayNumber" value={taskData.displayNumber} onChange={onTaskDataChange} />
            </div>
            <div className="form-group">
              <label>2. 공사명<span className="required-dot">*</span></label>
              <input className="form-control" type="text" name="name" value={taskData.name} onChange={onTaskDataChange} />
            </div>
            <div className="form-group">
              <label>3. 공사번호(감리)<span className="required-dot">*</span></label>
              <input className="form-control" type="text" name="number" value={taskData.number} onChange={onTaskDataChange} />
            </div>
            <div className="form-group">
              <label>4. 공사번호(본공사)</label>
              <input className="form-control" type="text" name="mainTaskNumber" value={taskData.mainTaskNumber} onChange={onTaskDataChange} />
            </div>
            <div className="form-group">
              <label>5. 본부<span className="required-dot">*</span></label>
              <select className="form-control" name="headquarters" value={taskData.headquarters} onChange={onTaskDataChange} required>
                <option value="">선택하세요</option>
                {headquartersOptions.map(hq => <option key={hq} value={hq}>{hq}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>6. 지사<span className="required-dot">*</span></label>
              <select className="form-control" name="branch" value={taskData.branch} onChange={onTaskDataChange} required>
                <option value="">선택하세요</option>
                {branchOptions.map(b => <option key={b} value={b}>{b}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>7. 종류<span className="required-dot">*</span></label>
              <select className="form-control" name="type" value={taskData.type} onChange={onTaskDataChange}>
                <option value="">선택하세요</option>
                <option value="단가">단가</option>
                <option value="총가">총가</option>
              </select>
            </div>
            <div className="form-group">
              <label>8. 공기일<span className="required-dot">*</span></label>
              <input className="form-control" type="text" name="period" value={taskData.period} onChange={onTaskDataChange} />
            </div>
            <div className="form-group">
              <label>9. 책임감리</label>
              <MultiSelectSupervisor
                supervisors={supervisors}
                selectedSupervisors={selectedManagers}
                onSelectionChange={(values) => {
                  setSelectedManagers(values);
                  onTaskDataChange({ target: { name: 'managers', value: values } });
                }}
                placeholder="책임감리원을 선택하세요"
                isManager={true}
                otherSelectedSupervisors={selectedAssistants}
              />
            </div>
            <div className="form-group">
              <label>10. 보조감리</label>
              <MultiSelectSupervisor
                supervisors={supervisors}
                selectedSupervisors={selectedAssistants}
                onSelectionChange={(values) => {
                  setSelectedAssistants(values);
                  onTaskDataChange({ target: { name: 'assistants', value: values } });
                }}
                placeholder="보조감리원을 선택하세요"
                isManager={false}
                otherSelectedSupervisors={selectedManagers}
              />
            </div>
            <div className="form-group">
              <label>11. 한전담당</label>
              <input className="form-control" type="text" name="kepcoManager" value={taskData.kepcoManager || ''} onChange={onTaskDataChange} />
            </div>
            <div className="form-group">
              <label>12. 시공사<span className="required-dot">*</span></label>
              <select className="form-control" name="company" value={taskData.company} onChange={onTaskDataChange}>
                <option value="">선택하세요</option>
                {contractors.map((contractor) => (
                  <option key={contractor.id} value={contractor.name}>
                    {contractor.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>13. 공사 계약일<span className="required-dot">*</span></label>
              <input className="form-control" type="date" name="contractDate" value={taskData.contractDate} onChange={onTaskDataChange} />
            </div>
            <div className="form-group">
              <label>14. 공사 기간<span className="required-dot">*</span></label>
              <input className="form-control" type="text" name="constructionPeriod" value={taskData.constructionPeriod} onChange={onTaskDataChange} placeholder="YYYY-MM-DD ~ YYYY-MM-DD" />
            </div>
            <div className="form-group">
              <label>15. 현장주소(읍/면/동)</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <input
                  className="form-control"
                  type="text"
                  name="address"
                  value={taskData.address || ''}
                  readOnly // 주소는 검색을 통해서만 입력되므로 읽기 전용
                  placeholder="주소 검색 버튼을 클릭하세요"
                  style={{ flexGrow: 1 }}
                />
                <button type="button" className="action-button" onClick={handleAddressSearch} style={{ whiteSpace: 'nowrap' }}>
                  주소 검색
                </button>
              </div>
            </div>
            <div className="form-group">
              <label>16. 진행현황</label>
              <select className="form-control" name="taskStatus" value={taskData.taskStatus || '공사중'} onChange={onTaskDataChange}>
                <option value="공사중">공사중</option>
                <option value="준공">준공</option>
              </select>
            </div>
            <div className="form-group">
              <label>17. 완료보고현황</label>
              <select className="form-control" name="completionReportStatus" value={taskData.completionReportStatus || '미완료'} onChange={onTaskDataChange}>
                <option value="미완료">미완료</option>
                <option value="완료">완료</option>
              </select>
            </div>
            <div className="form-group">
              <label>18. 공사유형</label>
              <select className="form-control" name="constructionType" value={taskData.constructionType || '미정'} onChange={onTaskDataChange}>
                <option value="미정">미정</option>
                <option value="신규">신규</option>
                <option value="보수">보수</option>
                <option value="운영">운영</option>
              </select>
            </div>
            <div className="form-group">
              <label>19. 최초계약금액<span className="required-dot">*</span></label>
              <input className="form-control" type="text" name="initialContractAmount" value={taskData.initialContractAmount || ''} onChange={onTaskDataChange} placeholder="최초계약금액을 입력하세요" />
            </div>

            <div className="form-group">
              <label>20. 증감금액</label>
              <input className="form-control" type="text" name="changeAmount" value={taskData.changeAmount || '0'} readOnly placeholder="증감금액" />
            </div>
            <div className="form-group">
              <label>21. 계약금액</label>
              <input className="form-control" type="text" name="contractAmount" value={(Number(taskData.initialContractAmount || 0) + Number(taskData.changeAmount || 0)).toLocaleString()} readOnly />
            </div>
            <div className="form-group">
              <label>22. 준공금액(기성)</label>
              <input className="form-control" type="text" name="completionAmount" value={taskData.completionAmount || '0'} readOnly placeholder="준공금액(기성)" />
            </div>
            <div className="form-group">
              <label>23. 잔액</label>
              <input className="form-control" type="text" name="balance" value={(Number(taskData.initialContractAmount || 0) + Number(taskData.changeAmount || 0) - Number(taskData.completionAmount || 0)).toLocaleString()} readOnly />
            </div>
          </div>

          <div className="remarks-section">
            <label>공사개요</label>
            <textarea name="constructionOutline" value={taskData.constructionOutline || ''} onChange={onTaskDataChange} placeholder="공사 개요를 입력하세요"></textarea>
          </div>
          <div className="remarks-section">
            <label>비고</label>
            <textarea name="remarks" value={taskData.remarks || ''} onChange={onTaskDataChange} placeholder="비고 사항을 입력하세요"></textarea>
          </div>
          <div className="form-actions">
            <button type="submit" className="submit-button">등록하기</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateTaskModal;